import React from "react";
import "./styles.css";
import {
  Box,
  InputLabel,
  TextField,
  createTheme,
  ThemeProvider,
} from "@mui/material";
import { colors } from "../../common/pallette/colors";

const CustomTextField = (props: any) => {
  const {
    label,
    value,
    manageChange,
    width,
    isDisabled,
    type,
    isError,
    errorMessage,
  } = props;

  const theme = createTheme({
    components: {
      MuiFormLabel: {
        styleOverrides: {
          root: {
            fontSize: 12,
            color: colors.black.dark,
          },
        },
      },
      MuiInputBase: {
        styleOverrides: {
          input: {
            padding: "8px !important",
          },
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          input: {
            cursor: isDisabled ? "not-allowed" : "text",
          },
          root: {
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: colors.black.dark,
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: colors.black.dark,
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: colors.black.dark,
            },
            fontSize: "13px",
            cursor: isDisabled ? "not-allowed" : "text",
          },
        },
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <Box>
        <InputLabel className="labelStyle">{label}</InputLabel>
        <TextField
          disabled={isDisabled}
          sx={{ width: width ? width : "100%" }}
          label=""
          value={value}
          type={type ? type : "text"}
          error={isError}
          helperText={isError ? errorMessage : ""}
          onChange={(e) => {
            manageChange(e.target.value);
          }}
        />
      </Box>
    </ThemeProvider>
  );
};

export default CustomTextField;
